import { GlobalStyles } from "@mui/material";

export default function AppGlobalStyles() {
  return (
    <GlobalStyles
      styles={{
        ".fab:hover .fab-label": {
          display: "flex !important",
          maxWidth: "200px !important",
        },
      }}
    />
  );
}
